import React, { Fragment } from 'react';

import { Container, MainNav } from 'up-design-system-gex'

const Layout = props => (
    <>
        <HeaderComponent passedStyle={props.hasMaxWidth ? {} : { "max-width": "none" }} />
        <Container style={props.hasMaxWidth ? {} : { "max-width": "none" }}>
            {props.children}
        </Container>
        <FooterComponent />
        <div id="root-alerts" className="alert-container"></div>
        <div id="root-modals"></div>
    </>
)

function HeaderComponent(props) {
    return (
        <Container className="mb-large" style={props.passedStyle}>
            <MainNav
                itemClassName={"show-l"}
                logo={
                    <Fragment>
                        <img className='show-xs hide-m' style={{ width: '45px', padding: '10px' }} alt="GexPay" src="/images/gex_03.png" />
                        <img className='show-m' style={{ padding: '10px' }} alt="GexPay" src="/images/gex_02.png" />
                    </Fragment>
                }
                items={[]}
            />
        </Container>
    )
};

function FooterComponent() {
    return <footer></footer>
};

export default Layout;